import Breadcrumb from "../../../../../components/breadcrumbs/Breadcrumb.vue";
import AlocacaoElementosPrimarios from "../../../../../components/empenho-siaf/AlocacaoElementosPrimarios.vue";
import { EmpenhoSIAFService } from "../../../../../services/EmpenhoSIAFService";
import { SnackBarModule } from "../../../../../modules/SnackBarModule";

export default {
  name: "VisualizarEmpenhoSIAF",
  components: {
    Breadcrumb,
    AlocacaoElementosPrimarios
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'Página Inicial',
        disabled: false,
        href: '/',
      },
      {
        text: 'Processos de Compras',
        disabled: false,
        href: '/gerenciar-processos-compras',
      },
      {
        text: 'Gerenciar Empenho',
        disabled: false,
        href: '/gerenciar-empenhos-siaf',
      },
      {
        text: 'Visualizar Empenho',
        disabled: true
      }
    ],
    empenho: {},
    empenhoId: null,
    loading: false
  }),
  created() {
    this.empenhoId = this.$route.params.id;
    if (this.empenhoId) {
      this.carregarEmpenho();
    } else {
      SnackBarModule('ID do empenho não fornecido!', 'error');
      this.$router.push('/gerenciar-empenhos-siaf');
    }
  },
  methods: {
    async carregarEmpenho() {
      try {
        this.loading = true;

        const response = await EmpenhoSIAFService.show(this.empenhoId);

        if (!response.error && response.data) {
          this.empenho = response.data;
        } else {
          SnackBarModule('Não foi possível carregar os dados do empenho.', 'error');
          this.$router.push('/gerenciar-empenhos-siaf');
        }
      } catch (error) {
        console.error('Erro ao carregar empenho:', error);
        SnackBarModule('Ocorreu um erro ao carregar os dados do empenho.', 'error');
        this.$router.push('/gerenciar-empenhos-siaf');
      } finally {
        this.loading = false;
      }
    },
    getNumeroEmpenhoCompleto() {
      if (this.empenho.numero_empenho && this.empenho.ano_empenho) {
        return `${this.empenho.numero_empenho} / ${this.empenho.ano_empenho}`;
      }
      if (this.empenho.numero_empenho) {
        return this.empenho.numero_empenho;
      }
      return '-';
    },
    formatCnpjCpf(value) {
      if (!value) return '-';
      const cleaned = value.replace(/\D/g, '');
      if (cleaned.length === 11) {
        return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (cleaned.length === 14) {
        return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      return value;
    },
    formatCurrency(value) {
      if (!value && value !== 0) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
    },
    formatDate(date) {
      if (!date) return '-';
      if (typeof date === 'string') {
        const d = new Date(date);
        if (isNaN(d.getTime())) return date;
        return d.toLocaleDateString('pt-BR');
      }
      return new Date(date).toLocaleDateString('pt-BR');
    },
    getConformidadeOrcamentaria() {
      const qtde = this.empenho.conformidade_orcamentaria_qtde || 0;
      const valor = this.empenho.conformidade_orcamentaria_valor_total || 0;
      return `${qtde} / ${this.formatCurrency(valor)}`;
    },
    getConformidadeRP() {
      const qtde = this.empenho.conformidade_rp_qtde || 0;
      const valor = this.empenho.conformidade_rp_valor_total || 0;
      return `${qtde} / ${this.formatCurrency(valor)}`;
    },
    getReforcoEmpenho() {
      const qtde = this.empenho.reforco_empenho_qtde || 0;
      const valor = this.empenho.reforco_empenho_valor_total || 0;
      return `${qtde} / ${this.formatCurrency(valor)}`;
    },
    getAnulacaoEmpenho() {
      const qtde = this.empenho.anulacao_empenho_qtde || 0;
      const valor = this.empenho.anulacao_empenho_valor_total || 0;
      return `${qtde} / ${this.formatCurrency(valor)}`;
    },
    getAnulacaoConformidadeOrcamentaria() {
      const qtde = this.empenho.anulacao_conformidade_orcamentaria_qtde || 0;
      const valor = this.empenho.anulacao_conformidade_orcamentaria_valor_total || 0;
      return `${qtde} / ${this.formatCurrency(valor)}`;
    },
    getAnulacaoConformidadeRP() {
      const qtde = this.empenho.anulacao_conformidade_rp_qtde || 0;
      const valor = this.empenho.anulacao_conformidade_rp_valor_total || 0;
      return `${qtde} / ${this.formatCurrency(valor)}`;
    },
    getCancelamentoRP() {
      const qtde = this.empenho.cancelamento_rp_qtde || 0;
      const valor = this.empenho.cancelamento_rp_valor_total || 0;
      return `${qtde} / ${this.formatCurrency(valor)}`;
    },
    voltarParaGerenciar() {
      this.$router.push('/gerenciar-empenhos-siaf');
    }
  }
};
